<template>
  <div>
    <vx-tooltip text="Editar" color="primary" position="left">
      <feather-icon
        icon="EditIcon"
        svgClasses="hover:text-primary stroke-current mt-1 pointer"
        @click="open"
      />
    </vx-tooltip>
    <vs-prompt
      :title="title + ' ' + item.id"
      accept-text="Salvar"
      cancel-text="Cancelar"
      button-cancel="border"
      @cancel="cancel"
      @accept="save"
      @close="cancel"
      :is-valid="validateForm"
      :active.sync="activePrompt"
    >
      <div>
        <form>
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-input
                class="w-full mb-4 mt-5"
                placeholder="Nome"
                v-model="item.nome"
                :color="validateForm ? 'success' : 'danger'"
              />
            </div>
            <div class="vx-col w-full">
              <span class="vs-input--label">Objetivo</span>
              <el-select
                class="w-full"
                filterable
                clearable
                v-model="item.id_objetivo"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="(obj, index) in objetivos"
                  :value="obj.id"
                  :label="obj.nome"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
          </div>
        </form>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    itemCopy: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activePrompt: false,
      item: {},
      objetivos: [],
    };
  },
  computed: {
    validateForm() {
      return this.item.nome !== "";
    },
  },

  methods: {
    async open() {
      this.item = { ...this.itemCopy };
      this.activePrompt = true;
      await this.getObjetivos();
    },
    async saveData() {
      await this.$vs.loading();
      try {
        this.rows = await this.$http.put(
          `${this.url}/${this.item.id}`,
          this.item
        );
        this.$vs.notify(this.$notify.Success);
        this.$emit("done");
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        await this.$vs.loading.close();
      }
    },
    async save() {
      if (this.validateForm) {
        await this.saveData();
      }
    },
    async cancel() {},
    async getObjetivos(load = true) {
      load ? await this.$vs.loading() : 1;
      try {
        this.objetivos = await this.$http.get(`estrategia_objetivo`);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        load ? await this.$vs.loading.close() : 1;
      }
    },
  },
  async mounted() {},
};
</script>
